<template>
  <v-app app :class="{ 'background-dark': isDark, 'background-light': !isDark }">
    <v-container v-if="isReady">
      <Content />
      <v-footer
        v-if="scrolledToBottom"
        app
        padless
        class="caption align-content-center justify-center"
        fixed
        ref="footer"
      >
        <!-- footer solo abajo -->
        <a href="https://merlocode.com"></a>
      </v-footer>
    </v-container>
    <v-container v-else class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4" class="d-flex justify-center">
          <v-img
            v-if="isEstrella"
            src="https://media.giphy.com/media/iIRvp5LUrxNHQFzmtS/giphy.gif"
          />
          <v-img
            v-else-if="isCosteira"
            src="https://firebasestorage.googleapis.com/v0/b/beyla-1.appspot.com/o/amordebares.png?alt=media&token=08d2b6dc-c28f-47e3-8545-243e6a8191e7"
          />
          <v-img v-else :src="logo" />
        </v-col>
      </v-row>
    </v-container>
    <!-- <v-col class="d-flex align-baseline absolute-center" v-if="!showCookies"> -->

    <v-sheet
      class="mx-4 text-center"
      style="position: absolute;
    bottom: 0px;"
      v-if="!showCookies"
    >
      <div class="py-3">
        {{ $t("messageCookie") }}
        <a src="cookies">{{ $t("Ver política de cookies.") }}</a>
      </div>
      <v-btn class="mb-6" outlined color="primary" @click="aceptCookies">{{ $t("Continue") }}</v-btn>
    </v-sheet>
    <!-- </v-col> -->
  </v-app>
</template>

<script>
import Content from "@/views/Content";
import firestore from "@/firebase/firestore";
import Logo from "@/components/Logo";
import vuex from "@/store.js";
import { auth } from "firebase";
import { store } from "@/store";
export default {
  name: "App",
  components: { Content, Logo },

  data() {
    return {
      search: "",
      user: null,
      shake: false,
      notReadyYet: false,
      logo: "",
      newUser: false,
      scrolledToBottom: false
    };
  },

  created() {
    if (this.isDark) {
      this.$vuetify.theme.dark = true;
      this.logo = require("@/assets/MerloLogoDark.png");
    } else {
      this.$vuetify.theme.dark = false;
      this.logo = require("@/assets/MerloLogoLight.png");
    }
    let that = this;
    setTimeout(function() {
      that.notReadyYet = true;
    }, 2000);
    this.setLocale();
    if (this.$store.state.confirmedCookies) {
      this.authenticate();
    }
  },

  computed: {
    isDark() {
      return window.matchMedia("(prefers-color-scheme: dark)").matches;
    },
    showCookies() {
      return this.$store.state.confirmedCookies;
    },
    isReady() {
      this.setLocale();
      return (
        this.notReadyYet &
        this.$store.getters.isReady &
        this.$store.state.confirmedCookies
      );
    },
    isEstrella() {
      return window.location.href.includes("estrellagalicia");
    },
    isCosteira() {
      return window.location.href.includes("costeira");
    }
  },

  async mounted() {
    this.scroll();

    if (this.$route.name == "clientViewerId") {
      this.newUser = true;
      let locationCode = this.$route.params.locationCode;

      this.$store.state.locationCode = locationCode;
      this.newLocationCode = true;
      if (!this.$store.state.session) {
        vuex.commit("set", {
          varName: "session",
          value:
            "_" +
            Math.random()
              .toString(36)
              .substr(2, 9)
        });
      }
      this.$router.replace("/");
    }

    // TODO Return just the menuId and inject it into a js object
    // let menu = await Functions.getMenu(store.state.locationCode);
    // menu = { id: menu.id };
    // Insert id into store so it finally loads data
    // store.state.menu = menu;
  },
  methods: {
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          Math.max(
            window.pageYOffset,
            document.documentElement.scrollTop,
            document.body.scrollTop
          ) +
            window.innerHeight ===
          document.documentElement.offsetHeight;

        if (bottomOfWindow) {
          this.scrolledToBottom = true;
        } else {
          this.scrolledToBottom = false;
        }
      };
    },
    setLocale() {
      const html = document.documentElement;
      if (this.$store.getters.menu && this.$store.getters.menu.locale) {
        html.setAttribute("lang", this.$store.getters.menu.locale);
        this.$i18n.locale = this.$store.getters.menu.locale;
      } else {
        this.$i18n.locale = navigator.languages[0];
        html.setAttribute("lang", "es");
      }
    },
    aceptCookies() {
      vuex.commit("set", { varName: "confirmedCookies", value: true });
      this.authenticate();
    },
    previousOrdersArePaid() {
      let paid = true;
      this.$store.state._orders.forEach(order => {
        paid = order.hasBeenPaid ? paid : order.hasBeenPaid;
      });
      return paid & (this.$store.state._orders.length > 0);
    },
    authenticate() {
      auth()
        .signInAnonymously()
        .catch(() => {});
      let store = this.$store;
      auth().onAuthStateChanged(async user => {
        if (user) {
          let db = firestore;
          let locationCode = store.state.locationCode;
          if (locationCode) {
            let snapshot = await db
              .collection("locationCodes")
              .doc(locationCode)
              .get();
            let restaurantId = snapshot.data().restaurant;
            let location = snapshot.data().location;
            this.$store.commit("set", {
              varName: "location",
              value: location
            });
            this.$store.commit("set", {
              varName: "restaurantId",
              value: restaurantId
            });
            this.$store.dispatch("bindLocation");

            this.$store.dispatch("bindMenu");
            this.$store.state._uid = user.uid;

            if (this.newUser) {
              const Activity = (await import("@/model/activity")).default;
              let activity = Activity.fromMap({
                location: location,
                type: "readMenu",
                date: new Date()
              });

              activity.save();

              this.$gtag.event(
                "new user in " + this.$store.state._locationObject.name,
                {
                  location: this.$store.state.location,
                  locationName: this.$store.state._locationObject.name,
                  restaurantId: this.$store.state.restaurantId
                }
              );

              if (this.previousOrdersArePaid())
                vuex.commit("set", {
                  varName: "session",
                  value:
                    "_" +
                    Math.random()
                      .toString(36)
                      .substr(2, 9)
                });
            }
            // store.dispatch("bindCustomer");
            store.dispatch("bindOrders");
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.background-dark {
  background-color: #1e1e1e !important;
}
.background-light {
  background-color: white !important;
}
</style>
